import { ArrowLeft as RawArrowLeft } from "@bookpeep/ui";
import { styled } from "@mui/material";

// The problem with this approach is that it could interfere with other instances of "transform"
const ArrowLeft = styled(RawArrowLeft)(({ theme }) => ({
  transform: theme.direction === "rtl" ? "scale(-1, 1)" : "none",
}));

export default ArrowLeft;
